import React, { ReactNode } from 'react';
import { FilterButtonDirection, OverlappingFilterButtonDetail } from '../common/util/OverlappingFilterUtils';
import { FilterOrientation } from '../components/dashboard/filtering/FilterComponent';

export class DashboardUtils {
    static renderFilterComponent = (component: ReactNode, visible: boolean, className: string) => {
        return (
            <div className={className} style={{ position: 'absolute', display: visible ? 'block' : 'none' }}>
                <div style={{ position: 'relative' }}>
                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                        {component}
                    </div>
                </div>
            </div>
        );
    };

    static getFilterOrientation = (
        filterButtonDetails: OverlappingFilterButtonDetail<any, any>,
        filterType: 'vertical' | 'horizontal',
    ): FilterOrientation => {
        if (filterType === 'vertical') {
            return filterButtonDetails.direction === FilterButtonDirection.FORWARD ? 'TTB' : 'BTT';
        } else {
            return filterButtonDetails.direction === FilterButtonDirection.FORWARD ? 'LTR' : 'RTL';
        }
    };

    static getButtonDetailsOnEnabledUpdate = (
        filterButtonDetails: OverlappingFilterButtonDetail<any, any>,
        enabled: boolean,
    ) => {
        return filterButtonDetails.copy({ enabled: enabled });
    };

    static getButtonDetailsOnOrientationUpdate = (
        filterButtonDetails: OverlappingFilterButtonDetail<any, any>,
        newOrientation: FilterOrientation,
    ) => {
        if (newOrientation === 'TTB' || newOrientation === 'BTT') {
            return filterButtonDetails.copy({
                direction: newOrientation === 'TTB' ? FilterButtonDirection.FORWARD : FilterButtonDirection.BACKWARD,
            });
        } else {
            return filterButtonDetails.copy({
                direction: newOrientation === 'LTR' ? FilterButtonDirection.FORWARD : FilterButtonDirection.BACKWARD,
            });
        }
    };
}
